import { IBaseModel, BaseModel } from '../base.model';

export interface IBMIBEditedViewModel extends IBaseModel {
  color: string,
  contractors: any[],
  fk_character_problem: number
}
export class BMIBEditedViewModel extends BaseModel implements IBMIBEditedViewModel {
  color: string
  contractors: any[]
  fk_character_problem: number

  constructor (color: string = null, contractors: any[] = [], fk_character_problem: number = null) {
    super()
    this.color = color
    this.contractors = contractors
    this.fk_character_problem = fk_character_problem
  }
}



// WEBPACK FOOTER //
// ./src/models/bm/bm-ib-edited.viewmodel.ts